import type { ReactElement } from 'react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { ErrorBoundaryFallback } from './ErrorBoundaryFallback';
import { reportBoundaryError } from './reportBoundaryError';

// The actual catch point for in-route crashes — see routes.tsx's errorElement wiring.
export const RouteErrorElement = (): ReactElement => {
    const error = useRouteError();

    useEffect(() => {
        reportBoundaryError(error);
    }, [error]);

    return <ErrorBoundaryFallback error={error} />;
};
